// Mermaid initialization config tuned to Mission Control palette.
// Mermaid does not accept OKLCH; values below are nearest sRGB hex
// equivalents to the OKLCH tokens documented in DESIGN.md. Keep these
// in lockstep with the design tokens — palette changes happen here.

export interface MermaidInitConfig {
  theme: "base";
  themeVariables: Record<string, string>;
  securityLevel: "strict";
  startOnLoad: boolean;
  fontFamily: string;
  flowchart: {
    curve: "linear";
    htmlLabels: boolean;
    padding: number;
  };
  sequence: {
    actorMargin: number;
    mirrorActors: boolean;
    showSequenceNumbers: boolean;
    boxMargin: number;
    messageMargin: number;
    useMaxWidth: boolean;
    diagramMarginX: number;
    diagramMarginY: number;
    actorFontSize: number;
    noteFontSize: number;
    messageFontSize: number;
    wrap: boolean;
    width: number;
  };
}

export const MERMAID_INIT_CONFIG: MermaidInitConfig = {
  theme: "base",
  themeVariables: {
    background: "#FFFFFF",
    primaryColor: "#E0F7F7",
    primaryBorderColor: "#00A0A0",
    primaryTextColor: "#1A2535",
    secondaryColor: "#F8F4ED",
    tertiaryColor: "#FFE7E7",
    lineColor: "#D7DCE4",
    textColor: "#1A2535",
    mainBkg: "#FFFFFF",
    clusterBkg: "#FAFBFC",
    clusterBorder: "#D7DCE4",
    titleColor: "#1A2535",
    edgeLabelBackground: "#FFFFFF",
    nodeBorder: "#00A0A0",
    actorBkg: "#E0F7F7",
    actorBorder: "#00A0A0",
    actorTextColor: "#1A2535",
    actorLineColor: "#5A6470",
    signalColor: "#1A2535",
    signalTextColor: "#1A2535",
    labelBoxBkgColor: "#FAFBFC",
    labelBoxBorderColor: "#D7DCE4",
    labelTextColor: "#1A2535",
    loopTextColor: "#1A2535",
    noteBkgColor: "#F8F4ED",
    noteBorderColor: "#D7B98A",
    noteTextColor: "#1A2535",
    activationBkgColor: "#E0F7F7",
    activationBorderColor: "#00A0A0",
    sequenceNumberColor: "#FFFFFF",
  },
  securityLevel: "strict",
  startOnLoad: false,
  fontFamily:
    'Outfit, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  flowchart: {
    curve: "linear",
    htmlLabels: false,
    padding: 12,
  },
  sequence: {
    actorMargin: 80,
    mirrorActors: false,
    showSequenceNumbers: true,
    boxMargin: 10,
    messageMargin: 45,
    // Render at natural size; the surrounding component provides pan + zoom
    // so the diagram doesn't get squashed into the card width.
    useMaxWidth: false,
    diagramMarginX: 40,
    diagramMarginY: 20,
    actorFontSize: 14,
    noteFontSize: 12,
    messageFontSize: 13,
    // Cap text width so long descriptions wrap to multiple lines instead of
    // pushing the whole diagram horizontally. Caller can also pre-insert
    // `<br>` at word boundaries for finer control.
    wrap: true,
    width: 180,
  },
};
